import React, { FunctionComponent, useContext, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Button, Dialog } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../../helpers";
import { County, ActionType } from "../../../@types";
import { Routes } from "../../../app";
import { AppContext } from "../../../app/store";
import ChangeLocationStatePicker from "./ChangeLocationStatePicker";
import thinX from "../../../assets/thin_x.svg";

const MedigapChangeLocation: FunctionComponent<RouteComponentProps> = ({
  history,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const onChangeLocation = (): void => {
    sendTealiumEvent(
      "Step 1: Decide what plans you want",
      "UI Option: Change location"
    );
    setShowModal(true);
  };
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);

  const onStateSelect = (county: County, zipcode: string): void => {
    setShowModal(false);

    dispatch({ type: ActionType.UPDATE_COUNTY, payload: county });
    dispatch({ type: ActionType.UPDATE_FIPS, payload: county.fips });
    dispatch({ type: ActionType.UPDATE_ZIPCODE, payload: zipcode });

    history.push(Routes.medigap.plans);
  };

  return (
    <div className="MedigapChangeLocation__link">
      <Button variation="transparent" onClick={onChangeLocation}>
        {t("medigap.change_location.link_text")}
      </Button>

      {showModal && (
        <Dialog
          heading={t("medigap.change_location.title.change_location")}
          className="MedigapChangeLocation__modal"
          closeText={
            <img aria-hidden="true" src={thinX} role="presentation" alt=" " />
          }
          closeButtonSize="big"
          closeButtonVariation="transparent"
          headerClassName="SelectStateModal__header"
          escapeExitDisabled={true}
          underlayClickExits={false}
          onExit={(): void => setShowModal(false)}
        >
          <ChangeLocationStatePicker onStateSelection={onStateSelect} />
        </Dialog>
      )}
    </div>
  );
};

export default withRouter(MedigapChangeLocation);
